module.exports = __webpack_public_path__ + "static/invite-lottery.8ab096d6.png";